import { createLogger } from '../../../helpers/loggerFacade';
import fixWebmBlobDuration from './fix-webm-duration';

const logger = createLogger('download-record-fix-record-chunks');

type FixRecordChunksArgs = {
    chunks: Blob[];
    mimeType: string;
    duration: number;
};

export const fixRecordChunks = async ({ chunks, mimeType, duration }: FixRecordChunksArgs): Promise<Blob> => {
    let blob = new Blob(chunks, { type: mimeType });

    // Фиксим продолжительность файла в хэдере
    try {
        // Для исправления продолжительности файла берем только самый первый чанк, который содержит всю
        // метаинформацию
        const toFixDurationBlob = new Blob(chunks.slice(0, 1), { type: mimeType });
        const fixedBlob = await fixWebmBlobDuration(toFixDurationBlob, duration);

        // Если удалось внести исправление, модифицированный первый кусок объединяем с остальными
        blob = new Blob([fixedBlob, ...chunks.slice(1)], { type: mimeType });
    } catch (error) {
        logger.error(error, { method: 'fixWebmDuration' });
    }

    return blob;
};
